<template>
  <div id="wallet" class="wallet_withdraw">
    <!-- 顶部导航栏 -->
    <van-nav-bar :title="$t('title.wallet')" placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow />
    <van-row class="wallet">
      <!-- 公告 -->
      <van-col span="22" offset="1" class="notice-bar" v-if="article_list.length > 0">
        <van-notice-bar left-icon="volume-o" :scrollable="false" color="#A253F5" background="#F6F0FD" mode="link">
            <template #left-icon>
                <img src="../assets/img/wallet_notice_bar.png" class="wallet_notice_bar_img"/>
            </template>
            <van-swipe
                vertical
                class="notice-swipe"
                :autoplay="3000"
                :show-indicators="false"
            >
                <van-swipe-item v-for="article in article_list" class="notice-swipe-item" :key="article.id" @click="showArticleDetail(article)">{{ article.title }}</van-swipe-item>
            </van-swipe>
        </van-notice-bar>
      </van-col>
      <!-- 总余额卡片 -->
      <van-col span="22" offset="1" class="withdraw_balance_card">
        <van-col span="14" offset="1">
            <van-col span="24" class="withdraw_total_amount"> <span v-if="is_display_balance">${{ totalBeans }}</span> <span v-else>****</span> </van-col>
            <van-col span="24" class="withdraw_total_label">
                {{ $t('wallet.withdrawal_amount') }}
                <span v-if="is_display_balance"><van-icon name="eye-o" @click="toggleDisplayBalance(false)"/></span>
                <span v-else><van-icon name="closed-eye" @click="toggleDisplayBalance(true)"/></span>
               
            </van-col>
        </van-col>
        <van-col span="8" class="withdraw_log_btn">
            <van-button color="#6A6970" round size="small" plain @click="showDetails">{{ $t('wallet.record') }}</van-button>
        </van-col>
        <van-col span="24" class="balance-card-bg1">
          <van-col span="22" offset="1">
            <van-col span="12">
              <van-col span="24" class="balance-value">
               <span v-if="is_display_balance">${{ withdrawalBeans }}</span> <span v-else>****</span> 
              </van-col>
               <van-col span="24" class="balance-label1">{{ $t('wallet.total_amount') }}</van-col>
            </van-col>
            <van-col span="12">
              <van-col span="24" class="balance-value1">
                <span v-if="is_display_balance"><img src="../assets/img/coin9.png" />{{ pendingBeans }}</span> <span v-else>****</span> 
              </van-col>
              <van-col span="20" class="balance-label1">{{ $t('wallet.confirmed') }} <van-icon name="question-o" size="12" /></van-col>
            </van-col>
          </van-col>
        </van-col>
      </van-col>
      <!-- Tab导航 -->
     <van-col span="24" class="payment-method-card">
        <van-col span="22" offset="1">
          <!-- 未添加支付方式 -->
          <van-col span="24" class="payment-method-empty" v-if="payment_method_list.length == 0">
            <van-col span="16" offset="1">
              <van-col span="24" class="payment-method-empty-title">{{ $t('wallet.method') }}</van-col>
              <van-col span="24" class="payment-method-empty-desc">{{ $t('wallet.add_payment_method') }}</van-col>
            </van-col>
            <van-col span="6" class="payment-method-empty-btn" @click="showPaymentTypeSelector">
              <img src="../assets/img/weekly-recharge-btn-right.png" />
            </van-col>
          </van-col>
          
          <!-- 已添加支付方式 -->
          <van-col span="24" class="payment-method-added" v-else>
            <van-col span="17" offset="1">
              <van-col span="24" class="payment-method-added-title">{{ $t('wallet.method') }}</van-col>
              <van-col span="24" class="payment-method-added-content">
                <van-col span="6" class="payment-method-icon" v-if="payment_method_list[currency_payment_id]">
                  <img :src="payment_method_list[currency_payment_id].img" />
                </van-col>
                <van-col span="18" v-if="payment_method_list[currency_payment_id]">
                  <van-col span="24" class="payment-method-name">{{ payment_method_list[currency_payment_id].name }}</van-col>
                  <van-col span="24" class="payment-method-tags">
                    <van-tag color="#FEF2C2" text-color="#FFA318" size="medium"> {{ $t('column.fee')}}: {{ payment_method_list[currency_payment_id].fee_description }}</van-tag>
                    <van-tag color="#F0EBFF" text-color="#A253F5" size="medium" style="margin-left: 5px;">{{ $t('wallet.arrival_24_hours') }}</van-tag>
                  </van-col>
                  <van-col span="24" class="payment-method-account" v-for="value in boundAccountList" :key="value.id">
                    {{ value.value }}
                  </van-col>
                </van-col>
              </van-col>
            </van-col>
            <van-col span="5" class="payment-method-manage-btn" @click="showPaymentTypeSelector">
               <img src="../assets/img/weekly-recharge-btn-jhuan.png" />
            </van-col>
          </van-col>
        </van-col>
     </van-col>
     <van-col span="22" offset="1" class="tab-nav" v-if="currency_payment_id">
       <van-col span="22" offset="1" class="fee-rules-title"> {{ $t('wallet.withdrawal_rate') }} </van-col>
      <van-col span="24" class="withdrawal-limits" v-if="payment_method_list[currency_payment_id]">
        <van-col span="24" class="withdrawal-limits-card">
          <!-- 汇率 -->
          <van-col span="24" class="withdrawal-rule-row">
            <van-col span="12" class="withdrawal-rule-label1"> {{ $t('wallet.exchange_ratio') }} </van-col>
            <van-col span="12" class="withdrawal-rule-value1">
              <img src="../assets/img/coin9.png" class="coin-icon-small1"/>{{ one_dollar_ticket || 0 }} = {{ payment_method_list[currency_payment_id].currency_name || '' }}{{ payment_method_list[currency_payment_id].currency_rate }}
            </van-col>
          </van-col>
          <!-- 最小提现金额 -->
          <van-col span="24" class="withdrawal-rule-row" v-if="payment_method_list[currency_payment_id].min_withdrawal > 0">
            <van-col span="12" class="withdrawal-rule-label1">
              {{ $t('wallet.min_withdrawal_amount') }}
            </van-col>
            <van-col span="12" class="withdrawal-rule-value1">
              ${{ payment_method_list[currency_payment_id].min_withdrawal }}
            </van-col>
          </van-col>
          
          <!-- 最大提现金额 -->
          <van-col span="24" class="withdrawal-rule-row" v-if="payment_method_list[currency_payment_id].max_withdrawal > 0">
            <van-col span="12" class="withdrawal-rule-label1">
              {{ $t('wallet.max_withdrawal_amount') }}
            </van-col>
            <van-col span="12" class="withdrawal-rule-value1">
              ${{ payment_method_list[currency_payment_id].max_withdrawal }}
            </van-col>
          </van-col>
        </van-col>
         <!-- 底部说明 -->
            <van-col span="24" class="fee-rules-note">
              <van-col span="24">1. {{ $t('wallet.rule_note_1') }}</van-col>
              <van-col span="24">2. {{ $t('wallet.rule_note_2') }}</van-col>
               </van-col>
                <!-- 按金额阶梯 -->
            <van-col span="24" v-if="currentFeeType == 1">
              <van-col span="24" class="withdrawal-limits-card">
                <van-col span="24" class="withdrawal-rule-row">
                  <van-col span="12" class="withdrawal-rule-label2">
                    {{ $t('wallet.withdrawal_amount') }}
                  </van-col>
                  <van-col span="12" class="withdrawal-rule-value2">
                    {{ $t('wallet.service_fee') }}
                  </van-col>
                </van-col>
                <van-col span="24" class="withdrawal-rule-row" v-for="(tier, index) in currentFeeTiers" :key="index">
                  <van-col span="12" class="withdrawal-rule-label3">
                    {{ (tier.min_amount || 0).toLocaleString() }} ≤ <img src="../assets/img/coin9.png" class="coin-icon-small"/> ≤ {{ (tier.max_amount || 0).toLocaleString() }}
                  </van-col>
                  <van-col span="12" class="withdrawal-rule-value3">
                    <span class="fee-rule-amount">
                      {{ ((tier.fee_rate || 0) * 100).toFixed(2) }}%
                    </span>
                  </van-col>
                </van-col>
              </van-col>
            </van-col>
            
            <!-- 按次数阶梯 -->
            <van-col span="24" v-if="currentFeeType == 2">
              <van-col span="24" class="withdrawal-limits-card">
                <van-col span="24" class="withdrawal-rule-row">
                  <van-col span="12" class="withdrawal-rule-label2">
                    {{ $t('wallet.monthly_withdrawal_count') }}
                  </van-col>
                  <van-col span="12" class="withdrawal-rule-value2">
                    {{ $t('wallet.service_fee') }}
                  </van-col>
                </van-col>
                <van-col span="24" class="withdrawal-rule-row" v-for="(tier, index) in currentFeeTiers" :key="index">
                  <van-col span="12" class="withdrawal-rule-label3">
                    {{ $t('wallet.times_range', {min: tier.min_times || 0, max: tier.max_times || 0}) }}
                  </van-col>
                  <van-col span="12" class="withdrawal-rule-value3">
                    <span class="fee-rule-amount">
                      {{ ((tier.fee_rate || 0) * 100).toFixed(2) }}%
                    </span>
                  </van-col>
                </van-col>
              </van-col>
            </van-col>
      </van-col>
     </van-col>
     <van-col span="22" offset="1" class="action-buttons-section">
       <van-button class="action-btn action-btn-primary" round block @click="showWithdrawDialog">{{ $t('wallet.cashout_now') }}</van-button>
       <van-button v-if="is_exchange" class="action-btn action-btn-secondary" round block @click="showExchangeDialog">{{ $t('wallet.exchange_beans_for_diamonds') }}</van-button>
       <van-button v-if="is_transfer" class="action-btn action-btn-secondary" round block @click="showTransferDialog">{{ $t('wallet.transfer') }}</van-button>
     </van-col>
     
      <van-popup v-model="CurrencyTypeShow" position="right" :style="{ height: '100%' }" >
        <van-col span="24" class="currency_payment_show_title">
          <van-col span="4" class="currency_type_title1"> <van-icon name="arrow-left" @click="CurrencyTypeShow = false" /> </van-col>
          <van-col span="16" class="currency_type_title1"> {{ $t('wallet.countries_regions') }} </van-col>
        </van-col>
        <van-col span="24">
            <van-search
              v-model="search_val"
              show-action
              :placeholder="$t('wallet.search_placeholder')"
              @input="onSearch"
              @cancel="onCancel"
            />
        </van-col>
        <van-col span="24" class="currency_type_list">
          <van-index-bar :index-list="indexList">
            <van-col span="24" v-for="(group, index) in currency_type" :key="index">
               <van-col class="currency_type_regions1" span="24">
                <van-col span="20" offset="2">{{ group.letter }}</van-col>
               </van-col>
              <van-index-anchor class="currency_type_index_status" :index="group.letter" />
              <van-cell v-for="country in group.countries" :key="country.id"  @click.native="CurrencyTypeSelect(country)">
                <van-col span="19"  class="currency_type_list_wallet_title" >
                  <img :src="country.country_img"/> {{ country.country_name }} <van-tag color="#F7F8FB" text-color="#1A1A1A">{{ country.currency_name }}</van-tag> <van-tag color="#FEF2C2" text-color="#1A1A1A" v-if="country.is_recommend ==1">{{ $t('column.recommend') }}</van-tag>
                </van-col>
                <van-col span="4" class="currency_type_list_wallet_code" >
                  + {{ country.country_code }} 
                </van-col>
              </van-cell>
            </van-col>
          </van-index-bar>
        </van-col>
      </van-popup>

      <van-popup v-model="CurrencyPaymentShow" position="right"  :style="{ height: '100%',width: '100%',background:'#F7F8FB' }" >
        <van-col span="24" class="currency_payment_show_title">
          <van-col span="4" class="currency_type_title1"> <van-icon name="arrow-left" @click="CurrencyPaymentShow = false" /> </van-col>
          <van-col span="8" offset="4" class="currency_type_title1"> {{ $t('wallet.method') }} </van-col>
          <van-col span="7" class="currency_type_title2" @click="CurrencyTypeShow = true"> {{ user_currency_one && user_currency_one.country_name ? user_currency_one.country_name : $t('wallet.country') }} </van-col>
        </van-col>
        <van-col span="22" offset="1" class="currency_payment_list">
          <van-col 
            span="24" 
            class="currency_payment_item"
            v-for="(j,ij) in recommend_currency_type" 
            :key="ij"
          >
            <van-col 
            span="24" 
            v-for="(c,i) in j.payment_method_type" 
            :key="i"
          >
            <van-col span="18" class="currency_payment_item_left" @click.native="CurrencyPaymentBtn(c)">
              <van-col span="5" class="currency_payment_icon">
                <img :src="c.img" />
              </van-col>
              <van-col span="19" class="currency_payment_info">
                <van-col span="24" class="currency_payment_name">{{ c.name }}</van-col>
                <van-col span="24" class="currency_payment_tags">
                  <van-tag color="#F0EBFF" text-color="#A253F5" size="medium">{{ $t('column.fee') }}:{{ c.fee_description }}</van-tag>
                  <van-tag color="#F0EBFF" text-color="#A253F5" size="medium" style="margin-left: 5px;">{{ $t('wallet.arrival') }}: 24 {{ $t('wallet.hours') }}</van-tag>
                </van-col>
              </van-col>
            </van-col>
            <van-col span="6" class="currency_payment_btn">
              <van-button 
                v-if="!c.is_bound_withdraw_account"
                color="#A253F5" 
                round 
                size="small"
                @click="showBindAccount(c, 'bind')"
              >
                {{ $t('wallet.bind') }}
              </van-button>
              <van-button 
                v-else
                color="#F6F0FD" 
                round 
                size="small"
                class="currency_payment_btn_color"
                @click="showBindAccount(c, 'view')"
              >
                {{ $t('wallet.view') }}
              </van-button>
            </van-col>
          </van-col>
          </van-col>
          <van-col 
            span="24" 
            class="currency_payment_item"
            v-if="user_currency_one"
            v-for="item in user_currency_one.payment_method_type" 
            :key="item.id"
          >
            <van-col span="18" class="currency_payment_item_left" @click.native="CurrencyPaymentBtn(item)">
              <van-col span="5" class="currency_payment_icon">
                <img :src="item.img" />
              </van-col>
              <van-col span="19" class="currency_payment_info">
                <van-col span="24" class="currency_payment_name">{{ item.name }}</van-col>
                <van-col span="24" class="currency_payment_tags">
                  <van-tag color="#F0EBFF" text-color="#A253F5" size="medium">{{ $t('column.fee') }}:{{ item.fee_description }}</van-tag>
                  <van-tag color="#F0EBFF" text-color="#A253F5" size="medium" style="margin-left: 5px;">{{ $t('wallet.arrival') }}: 24 {{ $t('wallet.hours') }}</van-tag>
                </van-col>
              </van-col>
            </van-col>
            <van-col span="6" class="currency_payment_btn">
              <van-button 
                v-if="!item.is_bound_withdraw_account"
                color="#A253F5" 
                round 
                size="small"
                @click="showBindAccount(item, 'bind')"
              >
                {{ $t('wallet.bind') }}
              </van-button>
              <van-button
                v-else
                color="#F6F0FD"
                round
                size="small"
                class="currency_payment_btn_color"
                @click="showBindAccount(item, 'view')"
              >
                {{ $t('wallet.view') }}
              </van-button>
            </van-col>
          </van-col>
        </van-col>
      </van-popup>
      <van-popup v-model="UserPaymentSelectorShow" position="bottom" closeable :style="{ height: '70%' }" round >
        <van-col span="24" class="wallet_currency_payment_show_title"> {{ $t('column.withdraw_payroll_list')}}  </van-col>
        <van-col span="22" offset="1" class="user_payment_selector_show_search">
          <van-search v-model="search_user_id" @search="search_user" :placeholder="$t('column.search_user_id')" />
        </van-col>
        <van-col span="22" offset="1">
          <van-list class="user_payment_selector_show_list">
            <van-cell v-for="t in search_user_list" :key="t.user_id" @click="UserPaymentSelectorBtn(t)">
              <van-col span="4" class="user_payment_selector_show_list_img">
                <img :src="t.head_image" />
              </van-col>
              <van-col span="20">
                <van-col span="24" class="user_payment_selector_show_list_name">{{ t.nick_name }}</van-col>
                <van-col span="24" class="user_payment_selector_show_list_id">ID:{{ t.user_id }}</van-col>
              </van-col>
            </van-cell>
          </van-list>
        </van-col>
      </van-popup>
      <van-popup v-model="articleDetailShow" position="center" round closeable :style="{ width: '90%', maxHeight: '80%' }">
        <van-col span="24" class="article-detail-title"> {{ currentArticle.title }} </van-col>
        <van-col span="24" class="article-detail-content" v-html="currentArticle.content"></van-col>
      </van-popup>
      
      <!-- 绑定账户弹框 -->
      <van-popup v-model="BindAccountShow" position="bottom" class="bind-account-popup" :style="{ height: '100%' }">
        <van-col span="24" class="bind-account-header">
          <van-col span="4" class="bind-account-back" @click="BindAccountShow = false">
            <van-icon name="arrow-left" />
          </van-col>
          <van-col span="16" class="bind-account-title">{{ bindAccountTitle }}</van-col>
        </van-col>
        <van-col span="24" class="bind-account-notice">
          {{ $t('wallet.bind_account_notice') }}
        </van-col>
        <van-col span="22" offset="1" class="bind-account-payment-info">
          <van-col span="6" class="bind-account-payment-icon">
            <img :src="currentBindPayment.img" />
          </van-col>
          <van-col span="18" class="bind-account-payment-detail">
            <van-col span="24" class="bind-account-payment-name">{{ currentBindPayment.name }}</van-col>
            <van-col span="24" class="bind-account-payment-tags">
              <van-tag color="#F0EBFF" text-color="#A253F5" size="medium">{{ $t('column.fee') }}: {{ currentBindPayment.fee_description }}</van-tag>
              <van-tag color="#F0EBFF" text-color="#A253F5" size="medium" style="margin-left: 5px;">{{ $t('wallet.arrival') }}: 24 {{ $t('wallet.hours') }}</van-tag>
            </van-col>
          </van-col>
        </van-col>
        
        <van-col span="22" offset="1" class="bind-account-form">
          <van-col span="24" class="bind-account-form-item" v-for="values in currentBindPayment.address_json" :key="values.id">
            <van-col span="24" class="bind-account-label">{{ values.name }}</van-col>
            <van-col span="24" class="bind-account-input-wrapper">
              <van-field
                v-model="bindAccountAddress[values.id]"
              />
              <van-icon name="close" class="bind-account-clear-icon" v-if="bindAccountAddress[values.id]" @click="bindAccountAddress[values.id] = ''" />
            </van-col>
          </van-col>
        </van-col>
        
        <van-col span="22" offset="1" class="bind-account-submit">
          <van-button color="#6A69F5" round block @click="submitBindAccount">{{ $t('btn.submit') }}</van-button>
        </van-col>
      </van-popup>

      <!-- 提现输入弹框 -->
      <van-popup v-model="WithdrawInputDialogShow" position="bottom" class="withdraw-dialog-popup" :style="{ height: '100%' }" >
        <van-col span="24" class="withdraw-dialog-header">
          <van-col span="4" class="withdraw-dialog-back" @click="WithdrawInputDialogShow = false">
            <van-icon name="arrow-left" />
          </van-col>
          <van-col span="16" class="withdraw-dialog-title">{{ $t('wallet.withdraw') }}</van-col>
        </van-col>
        <van-col span="22" offset="1" class="withdraw-dialog-content">
          <van-col span="24" class="withdraw-dialog-input-card">
            <van-col span="24" class="withdraw-dialog-input-wrapper">
              <span class="withdraw-dialog-input-prefix">$</span>
              <input
                type="number"
                class="withdraw-dialog-input"
                v-model="cashoutAmount"
                :placeholder="$t('column.please_enter')"
                @input="cashoutAmountInput"
              />
            </van-col>
              <van-col span="24" class="withdraw-dialog-balance">
                {{ $t('wallet.withdrawable_amount') }}: ${{ withdrawalBeans }}
              </van-col>
          </van-col>
          <van-col span="24" class="withdraw-dialog-error" v-if="cashoutAmountMessage">
            {{ cashoutAmountMessage }}
          </van-col>
        </van-col>
        <van-col span="22" offset="1" class="withdraw-dialog-submit">
          <van-button round block @click="submitCashout" class="withdraw-dialog-submit-btn">{{ $t('btn.submit') }}</van-button>
        </van-col>
      </van-popup>
    <!-- 提现成功弹框 -->
    <van-dialog
      v-model="WithdrawSuccessDialogShow"
      :title="$t('wallet.withdrawal_submitted')"
      :close-on-click-overlay="false"
      show-cancel-button
      :confirm-button-text="$t('wallet.check_details')"
      :cancel-button-text="$t('wallet.back')"
      confirm-button-color="#ffffff"
      class="withdraw-confirm-dialog"
      @confirm="goToWalletDetails"
      @cancel="onWithdrawSuccessBack"
    ></van-dialog>
    </van-row>

  </div>
</template>

<script>

import Toast from 'vant/lib/toast'
import axios from "axios";
import {Dialog} from "vant";

export default {
  name: 'Wallet',
  filters: {
    formatMoney(value) {
      if (value === undefined || value === null) return '0'
      // 保留两位小数，去除末尾的0
      return parseFloat(value.toFixed(2)).toString()
    }
  },
  data() {
    return {
      article_list: [],
      is_display_balance: localStorage.getItem('is_display_balance') === 'true',
      search_val: '',
      original_currency_data: [], // 保存原始国家数据用于搜索
      user_currency_one: {},
      CurrencyTypeShow: false,
      CurrencyPaymentShow: false,
      UserPaymentSelectorShow: false,
      ticket_name: '',
      totalBeans: 0,
      withdrawalBeans: 0,
      pendingBeans: 0,
      cashoutAmount: '',
      currency_type: [],
      indexList: [],
      recommend_currency_type: [],
      currency_list: [],
      payment_method_list:[],
      currency_type_id: 0,
      currency_payment_id: 0,
      cashout: {
        AddressJson: null,
      },
      is_official_currency_payment: 0,
      currency_user_list: [],
      currency_user_id: 0,
      search_user_list: [],
      search_user_id: undefined,
      one_dollar_ticket: 0,
      cashoutAmountMessage: '',
      monthly_withdrawal_count: 0, // 🆕 本月已提现次数
      articleDetailShow: false,
      currentArticle: {},
      // 绑定账户相关
      BindAccountShow: false,
      bindAccountTitle: '',
      currentBindPayment: {},
      bindAccountAddress: {},
      // 提现输入弹框
      WithdrawInputDialogShow: false,
      // 提现成功弹框
      WithdrawSuccessDialogShow: false,
      // 提现成功订单ID
      withdrawOrderId: '',
      is_coin_seller: 0,
      is_transfer: 0,
      is_exchange: 0,
    }
  },
  created() {
    this.get_list()
  },
  mounted() {
    // 创建一个全局的toast容器，直接挂载到body上
    this.createGlobalToastContainer()
  },
  computed: {
    // 🆕 新增
    currentFeeType() {
      if (this.payment_method_list && this.payment_method_list[this.currency_payment_id]) {
        return this.payment_method_list[this.currency_payment_id].fee_type || 0
      }
      return 0
    },
    boundAccountList() {
      if (this.payment_method_list && this.payment_method_list[this.currency_payment_id]) {
        const data = this.payment_method_list[this.currency_payment_id].bound_withdraw_account
        if (!data) return []
        if (Array.isArray(data)) return data.slice(0, 1)
        if (typeof data === 'string') {
          try {
            const parsed = JSON.parse(data)
            return Array.isArray(parsed) ? parsed.slice(0, 1) : []
          } catch (e) {
            return []
          }
        }
        return []
      }
      return []
    },
    currentFeeTiers() {
      console.log('currentFeeTiers')
      if (this.payment_method_list && this.payment_method_list[this.currency_payment_id]) {
        const feeTiers = this.payment_method_list[this.currency_payment_id].fee_tiers
        console.log('fee_tiers raw:', feeTiers)
        console.log('fee_tiers type:', typeof feeTiers)
        console.log('fee_tiers length:', Array.isArray(feeTiers) ? feeTiers.length : 'not array')
        
        // 确保返回的是数组
        if (Array.isArray(feeTiers)) {
          return feeTiers
        }
        
        // 如果是字符串，尝试解析
        if (typeof feeTiers === 'string') {
          try {
            const parsed = JSON.parse(feeTiers)
            console.log('fee_tiers parsed:', parsed)
            return Array.isArray(parsed) ? parsed : []
          } catch (e) {
            console.error('fee_tiers parse error:', e)
            return []
          }
        }
        
        return []
      }
      return []
    }
  },
  methods: {
    toggleDisplayBalance(val) {
      this.is_display_balance = val
      localStorage.setItem('is_display_balance', val)
    },
    createGlobalToastContainer() {
      // 确保Toast容器在body上
      if (!document.getElementById('global-toast-container')) {
        const container = document.createElement('div')
        container.id = 'global-toast-container'
        container.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: 100000;'
        document.body.appendChild(container)
      }
    },

    onCancel(){
       this.currency_set(filteredCountries, true);
    },
    onSearch(){
      if (!this.search_val) {
        // 如果搜索值为空，显示原始数据
        this.currency_set(this.original_currency_data);
      } else {
        // 根据搜索值过滤国家
        const query = this.search_val.toLowerCase();
        let filteredCountries = [];
        
        // 遍历所有国家进行模糊搜索
        if (this.original_currency_data && this.original_currency_data.length > 0) {
          this.original_currency_data.forEach(country => {
            // 检查国家名称是否匹配
            const nameMatch = country.country_name && country.country_name.toLowerCase().includes(query);
            // 检查国家代码是否匹配
            const codeMatch = country.country_code && country.country_code.toString().toLowerCase().includes(query);
            // 检查货币名称是否匹配
            const currencyMatch = country.currency_name && country.currency_name.toLowerCase().includes(query);
            // 检查字母是否匹配
            const letterMatch = country.letter && country.letter.toLowerCase().includes(query);
            
            if (nameMatch || codeMatch || currencyMatch || letterMatch) {
              filteredCountries.push(country);
            }
          });
        }
        
        // 更新显示过滤后的数据
        this.currency_set(filteredCountries);
      }
    },
    // 🆕 新增：获取本月提现次数
    getMonthlyWithdrawalCount() {
      // 调用API获取本月提现次数
       const uid = this.$route.query.uid
      const token = this.$route.query.token
       axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=wallet&act=get_monthly_withdrawal_count",{
        params:{uid: uid, token: token }
      }).then(res =>{
         if (res.data.code === 200) {
          this.monthly_withdrawal_count = res.data.data.count || 0
        }
      }).catch(err => {
        console.error('获取本月提现次数失败:', err)
      })
    },
    cashoutAmountInput() {
      this.cashoutAmountMessage = ''
      if (this.cashoutAmount > this.withdrawalBeans) {
        this.cashoutAmount = this.withdrawalBeans
      }
    },
    search_user() {
      if (!this.search_user_id) {
        this.search_user_list = this.currency_user_list
      }else{
        const query = this.search_user_id.toLowerCase();
        this.search_user_list =[]
        const userArray = Object.values(this.currency_user_list)
        for ( let i = 0; i < userArray.length; i++){
          const t = userArray[i]
          // 检查ID是否匹配（模糊）
          const idMatch = t.user_id.toString().toLowerCase().includes(query);
          // 如果ID或姓名匹配，则添加到结果列表
          if (idMatch) {
            this.search_user_list.push(t);
          }
        }
      }
    },
    UserPaymentSelectorBtn(t) {
      this.currency_user_id = t.user_id
      this.UserPaymentSelectorShow = false
    },
    showUserPaymentSelector() {
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast custom-toast-high-zindex',
        getContainer: () => document.getElementById('global-toast-container')
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=wallet&act=payroll_seller_payment_method",{
        params:{uid: uid, token: token, payment_method_id: this.currency_payment_id }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        console.log(res.data)
        if(res.data.status===1){
          this.currency_user_list = res.data.data.list
          this.search_user()
          this.UserPaymentSelectorShow = true
        }else{
          Toast({
            message: res.data.error,
            className: 'custom-toast-high-zindex',
            getContainer: () => document.getElementById('global-toast-container')
          })
        }
      })
    },
    CurrencyTypeSelect(item) {
      console.log('======dd==')
      console.log(item)
      this.currency_type_id = item.currency_type_id
      console.log(this.currency_type_id)
      console.log(this.currency_list)
      this.user_currency_one = this.currency_list[this.currency_type_id]
      this.CurrencyTypeShow = false
    },
    currency_set(countries){
      // 按字母分组国家数据
      let groups = {};
      let letters =[]
      countries.forEach(country => {
        const letter = country.letter;
        if (!groups[letter]) {
          groups[letter] = [];
        }
        groups[letter].push(country);
          if (!letters.includes(letter)) {
            letters.push(letter);
          }
      });
      // 排序并添加索引
      letters.sort();
      // 字母索引列表
      this.indexList = [...letters];

      this.currency_type = Object.keys(groups).sort().map(letter => ({
        letter,
        countries: groups[letter]
      }));
      console.log(this.currency_type)
      console.log(this.indexList)
      console.log('dddddddddd')
    },
    get_list() {
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast custom-toast-high-zindex',
        getContainer: () => document.getElementById('global-toast-container')
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=wallet&act=get_wallet_withdraw_info",{
        params:{uid: uid, token: token, date: this.date }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        console.log(res.data)
        if(res.data.status===1){
          this.totalBeans = res.data.data.total
          this.withdrawalBeans = res.data.data.withdrawal_total
          this.pendingBeans = res.data.data.pending_total
          this.ticket_name = res.data.data.ticket_name
          this.recommend_currency_type = res.data.data.official_country_list
          this.currency_list = res.data.data.currency_list
          this.one_dollar_ticket = res.data.data.one_dollar_ticket
          this.user_currency_one = res.data.data.user_currency_one
          this.original_currency_data = res.data.data.currency_type
          this.is_coin_seller = res.data.data.is_coin_seller
          this.article_list = res.data.data.article_list
          this.is_exchange = res.data.data.is_exchange
          this.is_transfer = res.data.data.is_transfer
          console.log('===dd6==');
          console.log(this.currency_list);
           console.log(this.recommend_currency_type);
          this.currency_set(this.original_currency_data)
          this.currency_payment_id =  res.data.data.payment_method_id
          this.currency_type_id = res.data.data.currency_type_id
            console.log('=====');
          console.log(this.currency_payment_id);
          if (this.currency_type_id && this.currency_payment_id && this.currency_list[this.currency_type_id]) {
            console.log('===22==');
            this.payment_method_list = this.currency_list[this.currency_type_id]['payment_method_type'] || []
            this.is_official_currency_payment  = this.currency_list[this.currency_type_id].is_official
              console.log(this.payment_method_list[this.currency_payment_id] ? this.payment_method_list[this.currency_payment_id].bound_withdraw_account : 'payment_method not found');
              console.log(this.is_official_currency_payment);
          }
          console.log('=====');
          console.log(this.payment_method_list);
           console.log(this.is_official_currency_payment);
           // 🆕 新增：获取本月提现次数
          this.getMonthlyWithdrawalCount()
        }else{
          Toast({
            message: res.data.error,
            className: 'custom-toast-high-zindex',
            getContainer: () => document.getElementById('global-toast-container')
          })
        }
      })
    },
    onClickLeft() {
     this.$router.go(-1)
    },
    showExchangeDialog() {
      // 判断是否是币商，如果是则跳转到币商兑换页面，否则跳转到普通兑换页面；
       const uid = this.$route.query.uid
      const token = this.$route.query.token
      if (this.is_coin_seller) {
        this.$router.push({ path: '/coin_dealer_exchange', query: { uid: uid, token: token } })
      } else {
        this.$router.push({ path: '/exchange_coin', query: { uid: uid, token: token } })
      }

    },
    showTransferDialog() {


    },
    // 提现成功-查看详情
    goToWalletDetails() {
      this.WithdrawSuccessDialogShow = false
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/withdraw_payroll_order', query: { uid: uid, token: token, order_id: this.withdrawOrderId } })
    },
    // 提现成功-返回刷新
    onWithdrawSuccessBack() {
      this.WithdrawSuccessDialogShow = false
      this.get_list()
    },
    showDetails() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/withdraw_record', query: { uid: uid, token: token } })
    },
    // 保存用户上次选择的支付方式
    saveLastPaymentMethod(paymentMethodId) {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=wallet&act=save_last_payment_method", {
        params: {
          uid: uid,
          token: token,
          payment_method_id: paymentMethodId
        }
      }).then(res => {
        if (res.data.status === 1) {
          console.log('保存支付方式选择成功:', paymentMethodId)
        } else {
          console.error('保存支付方式选择失败:', res.data.error)
        }
      }).catch(err => {
        console.error('保存支付方式选择失败:', err)
      })
    },
    CurrencyPaymentBtn(item){
      console.log('5566')
      console.log(item)
      if(item.bound_withdraw_account.length <= 0){
         Toast({
          message: this.$t('wallet.please_bind_account'),
          className: 'custom-toast-high-zindex',
          getContainer: () => document.getElementById('global-toast-container')
        })
        return
      }
      if(item.is_official == 1){
        this.currency_type_id = item.currency_type_id * 10000
      } else{
        this.currency_type_id = item.currency_type_id
      }
      this.currency_payment_id = item.id
      if (this.currency_list[this.currency_type_id]) {
        this.payment_method_list = this.currency_list[this.currency_type_id]['payment_method_type'] || []
      } else {
        this.payment_method_list = []
      }
      
      // 安全解析 address_json
      try {
        if (typeof item.address_json === 'string') {
          this.cashout.AddressJson = JSON.parse(item.address_json)
        } else if (Array.isArray(item.address_json)) {
          this.cashout.AddressJson = item.address_json
        } else {
          this.cashout.AddressJson = []
        }
      } catch (e) {
        console.error('address_json 解析失败:', e)
        this.cashout.AddressJson = []
      }
      
      console.log(this.cashout)
      console.log(item)
      this.currency_user_id = 0
      this.currency_user_list = []
      this.is_official_currency_payment = item.is_official + ''
      this.CurrencyPaymentShow = false
      
      // 调用接口保存用户选择的支付方式
      this.saveLastPaymentMethod(item.id)
    },
    showPaymentTypeSelector() {
      // this.currency_payment_id = 0
      // this.currency_user_id = 0
      // this.currency_user_list = []
      // console.log('====d===')
      // console.log(this.currency_type)
      this.CurrencyPaymentShow = true
    },
    selectAllCashout() {
      this.cashoutAmount = this.withdrawalBeans
    },
    showArticleDetail(article) {
      this.currentArticle = article
      this.articleDetailShow = true
    },
    showWithdrawDialog() {
      if (!this.currency_payment_id) {
        Toast({
          message: this.$t('wallet.please_add_payment_method'),
          className: 'custom-toast-high-zindex',
          getContainer: () => document.getElementById('global-toast-container')
        })
        return
      }
      this.WithdrawInputDialogShow = true
    },
    submitCashout() {
      if (!this.cashoutAmount || this.cashoutAmount <= 0) {
        Toast({
          message: this.$t('column.please_enter_amount'),
          className: 'custom-toast-high-zindex',
          getContainer: () => document.getElementById('global-toast-container')
        })
        return
      }
      if (this.cashoutAmountMessage) {
        return
      }
      Dialog.confirm({
        title: this.$t('wallet.withdrawal_amount'),
        message: '$' + this.cashoutAmount,
        className: 'withdraw-confirm-dialog',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=wallet&act=apply_withdrawal_from_bound_account",{
          params:{
            uid: uid,
            token: token,
            id: this.payment_method_list[this.currency_payment_id].id,
            money: this.cashoutAmount
          }
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          console.log(res.data)
          this.WithdrawInputDialogShow = false
          if(res.data.status ===1){
            this.cashoutAmount = undefined
            this.withdrawOrderId = res.data.data.order_id
            this.WithdrawSuccessDialogShow = true
          }else{
            Toast(res.data.error)
          }
        })
      })
    },
    // 显示绑定账户弹框
    showBindAccount(payment, title) {
      this.currentBindPayment = payment
      this.bindAccountTitle = this.$t('wallet.' + title)
      const isViewMode = title === 'view'
      
      // 解析 address_json 字符串为数组
      if (typeof payment.address_json === 'string') {
        try {
          this.currentBindPayment.address_json = JSON.parse(payment.address_json)
        } catch (e) {
          console.error('address_json 解析失败:', e)
          this.currentBindPayment.address_json = []
        }
      }
      
      // 初始化 bindAccountAddress 为对象，根据 address_json 的字段
      this.bindAccountAddress = {}
      if (this.currentBindPayment.address_json && Array.isArray(this.currentBindPayment.address_json)) {
        // 如果是查看已绑定的数据，先解析 bound_withdraw_account
        let savedAccountMap = {}
        if (isViewMode && payment.bound_withdraw_account) {
          try {
            // bound_withdraw_account 存储的是 account_info 数组，格式为 [{id, name, value}, ...]
            const savedAccountArray = typeof payment.bound_withdraw_account === 'string' 
              ? JSON.parse(payment.bound_withdraw_account) 
              : payment.bound_withdraw_account
            
            // 将数组转换为以 id 为 key 的对象，方便查找
            if (Array.isArray(savedAccountArray)) {
              savedAccountArray.forEach(item => {
                if (item && item.id) {
                  savedAccountMap[item.id] = item.value || ''
                }
              })
            }
          } catch (e) {
            console.error('bound_withdraw_account 解析失败:', e)
          }
        }
        
        // 根据 address_json 的字段初始化表单值
        this.currentBindPayment.address_json.forEach(field => {
          const savedValue = savedAccountMap[field.id] || ''
          this.$set(this.bindAccountAddress, field.id, savedValue)
        })
      }
      console.log('=======')
      console.log(this.bindAccountAddress)
      console.log(this.currentBindPayment.address_json)
      this.BindAccountShow = true
    },
    // 提交绑定账户
    submitBindAccount() {
      // 验证所有字段都已填写
      if (!this.currentBindPayment.address_json || !Array.isArray(this.currentBindPayment.address_json)) {
        Toast({
          message: this.$t('wallet.form_data_error'),
          className: 'custom-toast-high-zindex',
          getContainer: () => document.getElementById('global-toast-container')
        })
        return
      }
      
      for (let field of this.currentBindPayment.address_json) {
        if (!this.bindAccountAddress[field.id] || !this.bindAccountAddress[field.id].trim()) {
          Toast({
            message: this.$t('wallet.please_fill_in', {name: field.name}),
            className: 'custom-toast-high-zindex',
            getContainer: () => document.getElementById('global-toast-container')
          })
          return
        }
      }
      
      // 构建完整的地址信息对象
      const addressData = {}
      this.currentBindPayment.address_json.forEach(field => {
        addressData[field.id] = this.bindAccountAddress[field.id]
      })
      
      // TODO: 调用后端API提交绑定信息
      const toast = this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast custom-toast-high-zindex',
        getContainer: () => document.getElementById('global-toast-container')
      });

      const uid = this.$route.query.uid
      const token = this.$route.query.token
      // 使用 params 配置对象传递 GET 请求参数
      axios.get(this.baseUrlApi + this.baseUrlPath+ "?ctl=wallet&act=bind_withdraw_account", {
        params: {
          uid: uid,
          token: token,
          payment_method_id: this.currentBindPayment.id,
          account_number: JSON.stringify(addressData)
        }
      }).then(res => {
        toast.clear()
        
        console.log('绑定结果:', res.data)
        if (res.data.status === 1) {
          // 先更新绑定状态
          this.updatePaymentMethodBindingStatus()
          console.log('状态更新完成')
          
          // 关闭弹框
          this.BindAccountShow = false
          
          Toast({
            message: res.data.error,
            duration: 2000,
            getContainer: () => document.getElementById('global-toast-container')
          });
        } else {
          Toast({
            message: res.data.error,
            className: 'custom-toast-high-zindex',
            getContainer: () => document.getElementById('global-toast-container')
          })
        }
      }).catch(err => {
        toast.clear()
        Toast({
          message: this.$t('wallet.bind_failed_retry'),
        
          className: 'custom-toast-high-zindex',
          getContainer: () => document.getElementById('global-toast-container')
        })
        console.error('绑定账户失败:', err)
      })
    },
    // 更新支付方式绑定状态(不刷新整个列表)
    updatePaymentMethodBindingStatus() {
      console.log('=== updatePaymentMethodBindingStatus 开始 ===')
      const paymentMethodId = this.currentBindPayment.id
      console.log('paymentMethodId:', paymentMethodId)
      console.log('paymentMethodId 类型:', typeof paymentMethodId)
          
      // 构建绑定账户数据
      const boundAccountData = []
      if (this.currentBindPayment.address_json && Array.isArray(this.currentBindPayment.address_json)) {
        this.currentBindPayment.address_json.forEach(field => {
          boundAccountData.push({
            id: field.id,
            name: field.name,
            value: this.bindAccountAddress[field.id] || ''
          })
        })
      }
      console.log('boundAccountData:', boundAccountData)
      
      // 直接更新 currentBindPayment（它是原始数据的引用）
      console.log('直接更新 currentBindPayment...')
      this.$set(this.currentBindPayment, 'is_bound_withdraw_account', 1)
      this.$set(this.currentBindPayment, 'bound_withdraw_account', boundAccountData)
      console.log('currentBindPayment 更新后:', this.currentBindPayment)
          
      // 同时更新所有可能的数据源（确保数据一致性）
      // 更新 recommend_currency_type 中的数据
      console.log('检查 recommend_currency_type:', this.recommend_currency_type)
      if (this.recommend_currency_type && Array.isArray(this.recommend_currency_type)) {
        this.recommend_currency_type.forEach(country => {
          console.log('country:', country.country_name, 'payment_method_type:', country.payment_method_type)
          if (country.payment_method_type && Array.isArray(country.payment_method_type)) {
            const paymentMethod = country.payment_method_type.find(pm => {
              console.log('比较 pm.id:', pm.id, '类型:', typeof pm.id, '与 paymentMethodId:', paymentMethodId)
              return pm.id == paymentMethodId  // 使用 == 而不是 === 来兼容类型差异
            })
            if (paymentMethod) {
              console.log('✓ 更新 recommend_currency_type 中的支付方式:', paymentMethod.name)
              this.$set(paymentMethod, 'is_bound_withdraw_account', 1)
              this.$set(paymentMethod, 'bound_withdraw_account', boundAccountData)
            } else {
              console.log('✗ 在 recommend_currency_type 中未找到 paymentMethodId:', paymentMethodId)
            }
          }
        })
      }
          
      // 更新 user_currency_one 中的数据
      console.log('检查 user_currency_one:', this.user_currency_one)
      if (this.user_currency_one && this.user_currency_one.payment_method_type && Array.isArray(this.user_currency_one.payment_method_type)) {
        console.log('user_currency_one.payment_method_type:', this.user_currency_one.payment_method_type)
        const paymentMethod = this.user_currency_one.payment_method_type.find(pm => {
          console.log('比较 pm.id:', pm.id, '类型:', typeof pm.id, '与 paymentMethodId:', paymentMethodId)
          return pm.id == paymentMethodId  // 使用 == 而不是 === 来兼容类型差异
        })
        if (paymentMethod) {
          console.log('✓ 更新 user_currency_one 中的支付方式:', paymentMethod.name)
          this.$set(paymentMethod, 'is_bound_withdraw_account', 1)
          this.$set(paymentMethod, 'bound_withdraw_account', boundAccountData)
        } else {
          console.log('✗ 在 user_currency_one 中未找到 paymentMethodId:', paymentMethodId)
        }
      }
          
      // 更新 payment_method_list 中的数据（payment_method_list 是数组）
      console.log('检查 payment_method_list:', this.payment_method_list)
      if (this.payment_method_list && Array.isArray(this.payment_method_list)) {
        console.log('payment_method_list 长度:', this.payment_method_list.length)
        const paymentMethod = this.payment_method_list.find(pm => {
          console.log('比较 pm.id:', pm.id, '类型:', typeof pm.id, '与 paymentMethodId:', paymentMethodId)
          return pm.id == paymentMethodId  // 使用 == 而不是 === 来兼容类型差异
        })
        if (paymentMethod) {
          console.log('✓ 更新 payment_method_list 中的支付方式:', paymentMethod.name)
          this.$set(paymentMethod, 'is_bound_withdraw_account', 1)
          this.$set(paymentMethod, 'bound_withdraw_account', boundAccountData)
        } else {
          console.log('✗ 在 payment_method_list 中未找到 paymentMethodId:', paymentMethodId)
        }
      }
      
      // 强制触发视图更新
      this.$forceUpdate()
      console.log('=== updatePaymentMethodBindingStatus 结束 ===')
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/wallet_withdraw.vue